import { Link } from "react-router-dom";

const articles = [
  {
    title: "OOPBUY Spreadsheet Guide – Alles, was du wissen musst",
    desc: "Der umfassendste deutschsprachige Guide zur OOPBUY Spreadsheet. Egal ob Anfänger oder Profi – hier erfährst du alles über die besten Deals, QC und Versand.",
    image: "https://readdy.ai/api/search-image?query=Person%20browsing%20online%20shopping%20on%20laptop%20at%20cozy%20home%20desk%20with%20warm%20lamp%20light%20and%20coffee%20cup%20beside%2C%20plants%20in%20background%2C%20soft%20evening%20atmosphere%2C%20cream%20and%20wood%20tones%2C%20lifestyle%20editorial%20photography%2C%20relaxed%20productive%20mood&width=600&height=400&seq=article-card-001-v2&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-guide",
  },
  {
    title: "OOPBUY für Anfänger – Der komplette Einstiegsguide",
    desc: "Von Null zum ersten erfolgreichen Kauf in 30 Minuten. Schritt für Schritt durch Registrierung, Spreadsheet-Nutzung und erste Bestellung.",
    image: "https://readdy.ai/api/search-image?query=Clean%20organized%20desk%20with%20notebook%20and%20smartphone%20showing%20shopping%20interface%2C%20warm%20morning%20light%2C%20eucalyptus%20plant%20and%20ceramic%20mug%2C%20minimalist%20workspace%20setup%2C%20cream%20and%20soft%20green%20tones%2C%20productive%20calm%20atmosphere%2C%20editorial%20lifestyle%20flat%20lay%20photography&width=600&height=400&seq=article-card-anfaenger&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-anfaenger",
  },
  {
    title: "OOPBUY QC Prozess – Qualität richtig prüfen",
    desc: "QC-Fotos sind der wichtigste Schritt beim OOPBUY-Einkauf. Wir zeigen dir, worauf du achten musst und wie du Fehlkäufe vermeidest.",
    image: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20fabric%20swatch%20with%20visible%20weave%20pattern%20and%20stitching%20details%2C%20warm%20natural%20lighting%2C%20macro%20photography%20style%2C%20cream%20and%20beige%20tones%2C%20quality%20inspection%20concept%2C%20soft%20shadows%2C%20editorial%20product%20photography%20with%20scientific%20precision%20aesthetic&width=600&height=400&seq=article-card-qc&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-qc",
  },
  {
    title: "OOPBUY Versand nach Deutschland",
    desc: "DHL, EMS oder Tax-Free-Line? Wir vergleichen alle Versandoptionen von China nach Deutschland mit Zolltipps und Kosten.",
    image: "https://readdy.ai/api/search-image?query=Single%20premium%20parcel%20box%20opened%20with%20tissue%20paper%20and%20product%20peeking%20out%20on%20light%20wood%20surface%2C%20warm%20natural%20window%20light%2C%20unboxing%20anticipation%20moment%2C%20minimalist%20packaging%20aesthetic%2C%20cream%20and%20kraft%20paper%20tones%2C%20editorial%20e-commerce%20photography%2C%20soft%20shadows&width=600&height=400&seq=article-card-versand&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-versand",
  },
  {
    title: "Beste OOPBUY Spreadsheet für Sneaker 2026",
    desc: "Die beliebtesten Sneaker-Deals von verifizierten Verkäufern. Nike, Adidas, Jordan und Yeezy – hier findest du die aktuellsten Links.",
    image: "https://readdy.ai/api/search-image?query=Single%20pair%20of%20premium%20sneakers%20placed%20on%20concrete%20surface%20with%20dramatic%20natural%20light%20from%20window%20creating%20long%20shadows%2C%20urban%20minimalist%20aesthetic%2C%20closeup%20detail%20shot%20showing%20texture%20and%20craftsmanship%2C%20warm%20neutral%20tones%2C%20editorial%20sneaker%20photography%20with%20artistic%20composition&width=600&height=400&seq=article-card-sneaker&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-sneaker",
  },
  {
    title: "OOPBUY Coupons & Rabatte 2026",
    desc: "So sparst du richtig! Alle aktiven Gutscheine, Cashback-Tricks und versteckte Deals für deinen nächsten OOPBUY-Haul.",
    image: "https://readdy.ai/api/search-image?query=Smartphone%20displaying%20discount%20notification%20with%20shopping%20bags%20and%20receipt%20on%20light%20wood%20desk%2C%20warm%20cozy%20cafe%20atmosphere%2C%20golden%20hour%20lighting%2C%20lifestyle%20savings%20concept%2C%20cream%20and%20warm%20amber%20tones%2C%20editorial%20consumer%20photography%2C%20soft%20blurred%20background&width=600&height=400&seq=article-card-coupons&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-coupons",
  },
  {
    title: "OOPBUY vs andere Agenten – Der große Vergleich",
    desc: "OOPBUY, Pandabuy oder Wegobuy? Wir vergleichen alle Shopping-Agenten in Preis, Service und Versand für deutsche Käufer.",
    image: "https://readdy.ai/api/search-image?query=Balance%20scale%20with%20shopping%20icons%20on%20one%20side%20and%20price%20tags%20on%20other%2C%20conceptual%20comparison%20imagery%2C%20warm%20natural%20lighting%2C%20cream%20background%2C%20minimalist%20business%20concept%20photography%2C%20soft%20shadows%2C%20elegant%20composition%20with%20beige%20and%20gold%20tones&width=600&height=400&seq=article-card-vergleich&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-vergleich",
  },
  {
    title: "Sicher einkaufen – Betrug erkennen und vermeiden",
    desc: "So schützt du dich vor unseriösen Verkäufern. Lerne, echte Bewertungen von Fake zu unterscheiden und sicher zu bestellen.",
    image: "https://readdy.ai/api/search-image?query=Hand%20holding%20smartphone%20with%20verified%20checkmark%20badge%20displayed%2C%20warm%20natural%20light%2C%20shield%20and%20protection%20concept%2C%20cream%20background%20with%20soft%20shadows%2C%20trust%20and%20verification%20theme%2C%20editorial%20technology%20lifestyle%20photography%2C%20reassuring%20warm%20tones&width=600&height=400&seq=article-card-sicherheit&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-sicherheit",
  },
  {
    title: "Taobao & Weidian Guide – Die besten Shops",
    desc: "Navigiere chinesische Marktplätze wie ein Profi. So findest du die besten Shops, liest Bewertungen und entdeckst versteckte Perlen.",
    image: "https://readdy.ai/api/search-image?query=Organized%20desk%20with%20laptop%20showing%20marketplace%20grid%20layout%2C%20notebook%20with%20handwritten%20notes%20in%20multiple%20languages%2C%20warm%20task%20lighting%2C%20international%20shopping%20concept%2C%20cream%20and%20warm%20wood%20tones%2C%20productive%20workspace%20aesthetic%2C%20editorial%20business%20photography&width=600&height=400&seq=article-card-taobao&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-taobao",
  },
  {
    title: "OOPBUY Erfahrungen & Bewertungen 2026",
    desc: "Echte deutsche OOPBUY-Nutzer berichten. Ehrliche Reviews zu Bestellungen, QC, Versand und Kundenservice – die ungeschönte Wahrheit.",
    image: "https://readdy.ai/api/search-image?query=Five%20star%20rating%20display%20next%20to%20handwritten%20review%20card%20on%20warm%20linen%20fabric%2C%20testimonial%20concept%2C%20soft%20golden%20morning%20light%2C%20premium%20stationery%20aesthetic%2C%20cream%20and%20gold%20tones%2C%20elegant%20review%20presentation%20photography%2C%20authentic%20personal%20touch%20feeling&width=600&height=400&seq=article-card-erfahrungen&orientation=landscape",
    link: "/guide/oopbuy-spreadsheet-erfahrungen",
  },
];

export default function ArticlePreview() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            Neueste Guides & Artikel
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            Schritt-für-Schritt-Tutorials, die dir helfen, mit OOPBUY smarter einzukaufen.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {articles.map((article) => (
            <ArticleCard key={article.title} {...article} />
          ))}
        </div>

        <div className="text-center mt-8">
          <Link
            to="/sitemap"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            Alle Guides ansehen
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}

function ArticleCard({
  title,
  desc,
  image,
  link,
}: {
  title: string;
  desc: string;
  image: string;
  link: string;
}) {
  return (
    <Link
      to={link}
      className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 hover:shadow-sm transition-all duration-200"
    >
      <div className="aspect-[3/2] overflow-hidden">
        <img
          src={image}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-xs md:text-sm text-foreground-600 line-clamp-3 leading-relaxed mb-3">
          {desc}
        </p>
        <span className="inline-flex items-center gap-1 text-xs font-medium text-primary-600 group-hover:text-primary-700 transition-colors">
          Mehr lesen
          <span className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-line"></i>
          </span>
        </span>
      </div>
    </Link>
  );
}